import React from 'react';

interface StatusItemProps {
  label: string;
  value: string;
  variant?: 'default' | 'muted';
}

export const StatusItem: React.FC<StatusItemProps> = ({
  label,
  value,
  variant = 'default',
}) => {
  return (
    <div className="flex justify-between text-sm">
      <span>{label}</span>
      <span className={variant === 'muted' ? 'text-muted-foreground' : 'font-medium'}>
        {value}
      </span>
    </div>
  );
};
